/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import * as uuid from 'uuid'
import { AuthService } from './auth/auth.service'
import { UserSessionService } from './user-session.service'
import { ClikCRMService } from './auth/clikCRM.service'

@Injectable({
    providedIn: 'root',
})
export class InitService {
    constructor(
        private $http: HttpClient,
        private Session: UserSessionService,
        private authService: AuthService,
        private clikCRMService: ClikCRMService
    ) {}

    recoverSession() {
        let vm = this

        return new Promise<void>(function (accept, reject) {
            vm.Session.destroy()

            let urlParams = new URLSearchParams(window.location.search)
            let jwt = urlParams.get('jwt')
            let callSuffix = jwt ? '?jwt=' + encodeURIComponent(jwt) : ''
            vm.$http
                .get('/api/auth/current' + callSuffix)
                .toPromise()
                .then(
                    function (data: any) {
                        if (data) {
                            vm.Session.create(data.session_id, data.subject_name, data.roles, null)

                            sessionStorage.setItem('tdw.auth.authed', 'true')
                            if (!sessionStorage.getItem('tdw.auth.tabToken')) {
                                sessionStorage.setItem('tdw.auth.tabToken', uuid.v1())
                            }

                            vm.clikCRMService.getAccount().then(function (acct: any) {
                                vm.Session.crmAccounts = acct
                                accept()
                            })
                        } else {
                            vm.authService.logout()
                            accept()
                        }
                    },
                    function (response: any) {
                        accept()
                    }
                )
        })
    }
}
